import { IFAQService } from '@shared/interfaces/services/IFAQService';
import { PaginationRequestModel } from '@shared/models/Pagination/PaginationRequestModel';
import { PaginationResponseModel } from '@shared/models/Pagination/PaginationResponseModel';
import { FAQModel } from '@shared/models/FAQ/FAQModel';
import { ApiService } from '@shared/services/ApiService';

export class FAQWebSiteService extends ApiService implements IFAQService {
  constructor() {
    super('/faq/website');
  }

  getPublicFaq(params: PaginationRequestModel): Promise<PaginationResponseModel<any>> {
    return this.get('/public/get', { params });
  }

  getItems(params: PaginationRequestModel): Promise<PaginationResponseModel<FAQModel>> {
    return this.get('/get', { params });
  }

  addItem(params: FAQModel): Promise<void> {
    return this.post('/add', params);
  }

  updateItem(params: FAQModel): Promise<void> {
    return this.put('/update', params);
  }

  deleteItems(faqs: FAQModel[]): Promise<any> {
    const ids: string = faqs.map((faq) => `ids=${faq.id}`).join('&');
    return this.delete(`/delete?${ids}`);
  }
}
